export const waitSomeTime = (time: number) => {
  return new Promise<void>((resolve) => {
    const intervalId = setInterval(() => {
      console.log(`${time} seconds have passed!`);
      clearInterval(intervalId);
      resolve();
    }, time);
  });
};
